import { render, staticRenderFns } from "./h5-user-list.vue?vue&type=template&id=20c400d4&scoped=true&"
import script from "./h5-user-list.vue?vue&type=script&lang=js&"
export * from "./h5-user-list.vue?vue&type=script&lang=js&"
import style0 from "./h5-user-list.vue?vue&type=style&index=0&id=20c400d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c400d4",
  null
  
)

export default component.exports